import styled from 'styled-components';

import { Text12 } from '@sternum/ui';
import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const ErrorMessage = styled(Text12)`
  color: ${ct({ Dark: Colors.RedMiddle, Light: Colors.RedMiddle })};
`;

export const CaptchaWrapper = styled.div`
  > div {
    width: 240px !important;
    height: 61px !important;
    transform: scale(0.8);
    transform-origin: 0 0;
  }
`;
